import axios from "axios";
import { createUrl, createCloudinaryUrl } from "../utils/urlEnv";

export const getProducts = async ({ name, brand, serie, category, novelty, preorder, sales } = {}) => {
  try {
    let url = createUrl() + "/products";

    if (name) {
      url += `/name/${encodeURIComponent(name)}`;
    } else if (brand) {
      url += `/brand/${encodeURIComponent(brand)}`;
    } else if (serie) {
      url += `/serie/${encodeURIComponent(serie)}`;
    } else if (category) {
      url += `/category/${encodeURIComponent(category)}`;
    } else if (novelty) {
      url += `/created-at/`;
    } else if (preorder) {
      url += `/preorder/`;
    } else if (sales) {
      url += `/sales/`;
    }

    const response = await axios.get(url, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const getProductById = async (id) => {
  try {
    const response = await axios.get(createUrl() + "/products/" + id, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data; // This will be { products: [...] } or just [...] depending on your backend
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const getLatestTopProducts = async () => {
  try {
    const response = await axios.get(createUrl() + "/products/top", {
      headers: { "Content-Type": "application/json" },
    });
    return response.data; // This will be { products: [...] } or just [...] depending on your backend
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
}

export const getCategories = async () => {
  try {
    const response = await axios.get(createUrl() + "/categories", {
      headers: { "Content-Type": "application/json" },
    });
    return response.data; // This will be { categories: [...] } or just [...] depending on your backend
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const getUniqueCategories = async () => {
  try {
    const response = await axios.get(createUrl() + "/distinct-category", {
      headers: { "Content-Type": "application/json" },
    });
    return response.data; // This will be { categories: [...] } or just [...] depending on your backend
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
}

export const getUniqueBrands = async () => {
  try {
    const response = await axios.get(createUrl() + "/distinct-brand", {
      headers: { "Content-Type": "application/json" },
    });
    return response.data; // This will be { categories: [...] } or just [...] depending on your backend
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
}

export const getImagesByProductId = async (product_id) => {
  try {
    const response = await axios.get(
      createUrl() + "/product-images?productId=" + product_id,
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
  } catch (error) {
    console.error("Error getting images by product ID:", error);
    throw error;
  }
};

export const getAllImages = async () => {
  try {
    const response = await axios.get(createUrl() + "/product-images", {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting images by product ID:", error);
    throw error;
  }
};

const cloudinaryCache = new Map();

export const getImageUrlFromCloudinary = async (folderName, publicIds) => {
  if (typeof publicIds === "string") publicIds = [publicIds];

  const urls = [];
  const missed = [];
  const baseURL = "https://res.cloudinary.com/dt532gwwq/image/upload/v1/";

  //create url by concatenating folder + publicid
  publicIds.forEach((publicId) => {
    const url = `${baseURL}${publicId}?_a=BAMAPqZW0`;
    urls.push(url);
    cloudinaryCache.set(publicId, url);
  });

  return urls;
};

export const getFirstImageFromCloudinary = (folderName, publicIds) => {
  // Si viene como string JSON, convertirlo
  if (typeof publicIds === "string") {
    publicIds = JSON.parse(publicIds);
  }

  // Si viene como arreglo pero contiene un JSON serializado
  if (
    Array.isArray(publicIds) &&
    publicIds.length === 1 &&
    typeof publicIds[0] === "string" &&
    publicIds[0].startsWith("[")
  ) {
    publicIds = JSON.parse(publicIds[0]);
  }

  const firstImage = publicIds[0];
  const baseURL =
    "https://res.cloudinary.com/dt532gwwq/image/upload/v1/";

  const url = `${baseURL}/${firstImage}?_a=BAMAPqZW0`;

  return url;
};

const fetchCloudinaryUrlsBatch = async (folderName, publicIds) => {
  if (typeof publicIds === "string") publicIds = [publicIds];

  const batchSize = 6;
  const chunks = [];

  for (let i = 0; i < publicIds.length; i += batchSize) {
    chunks.push(publicIds.slice(i, i + batchSize));
  }

  let results = [];
  for (const chunk of chunks) {
    const batchResults = await Promise.all(
      chunk.map((publicId) =>
        axios.get(
          `${createCloudinaryUrl()}/images/${encodeURIComponent(folderName)}/${encodeURIComponent(publicId)}`,
        ),
      ),
    );
    results.push(...batchResults.map((r) => r.data.url));
    await new Promise((resolve) => setTimeout(resolve, 120)); // 120 ms de descanso
  }
  return results;
};

//Start all services
export const initStoreServices = async () => {
  try {
    const responseStore = await axios.get(createUrl() + "/health", {
      headers: { "Content-Type": "application/json" },
    });
    return "Store:" + responseStore.data;
  } catch (error) {
    console.error("Error starting services:", error);
    throw error;
  }
};

export const initCloudServices = async () => {
  try {
    const responseCloud = await axios.get(createCloudinaryUrl() + "/health", {
      headers: { "Content-Type": "application/json" },
    });
    return "Cloud:" + responseCloud.data;
  } catch (error) {
    console.error("Error starting services:", error);
    throw error;
  }
};